import jQuery from 'jquery';

let $ = jQuery;

let maps_autocomplete_service = null;
let maps_places_service = null;
let cache = [];
let googleMapsScriptIsInjected = false;

function getAutocompleteService() {
    if (!maps_autocomplete_service) {
        maps_autocomplete_service = new google.maps.places.AutocompleteService();
    }

    return maps_autocomplete_service;
}

function getMapsPlacesService(map) {
    maps_places_service = maps_places_service || new google.maps.places.PlacesService(map);
    return maps_places_service;
}

export default class Suggester {
    constructor(url, googleDecodeUrl, current_location, neighbours) {
        this.gotMapsInstance = false;
        this.url = url;
        this.googleDecodeUrl = googleDecodeUrl;
        this.currentLocation = current_location || false;
        this.neighbours = $.map(neighbours, (elem, index) => {
            elem.reference = elem.aid;
            elem.is_neighbour = true;
            return elem;
        }) || [];
    }

    prepareMaps() {
        $.when(
            $.getScript(`https://maps-api-ssl.google.com/maps/api/js?key=${GOOGLE_API_KEY}&v=3&libraries=places&language=${API_LOCALE}`),
            $.Deferred(function (deferred) {
                $(deferred.resolve);
            })
        ).done(function () {
            define('google/map-instance', ['google/maps'], function () {
                return new google.maps.Map(document.getElementById('map-canvas'));
            });
            getAutocompleteService();
            getMapsPlacesService(document.getElementById('map-canvas'));
            googleMapsScriptIsInjected = true;
        });
    }

    bind(input, callback, start_loading_callback, end_loading_callback, change_callback) {
        let autocomplete = input.autocomplete({
            minLength: 0,
            source: (request, response) => {
                this.source(request, response, start_loading_callback, end_loading_callback);
            },
            select: (event, ui) => {
                return this.select(event, ui, input, callback);
            },
            change: (event, ui) => {
                if (!ui.item) {
                    $(event.currentTarget).val('')
                    if ($.isFunction(change_callback)) {
                        change_callback();
                    }
                }
            },
            open: () => {
                return Suggester.open(input)
            },
            search: (event, ui) => {
                if (!googleMapsScriptIsInjected) {
                    this.prepareMaps();
                }
            },
        });

        $(input).on('click', () => {
            input.val('');
            input.autocomplete('search', '');
        });

        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            input.autocomplete('widget').off('menufocus hover mouseover');
        }
        autocomplete.data("ui-autocomplete")._renderItem = Suggester.renderItem;
        autocomplete.autocomplete('widget').addClass("autocomplete-locations");
    }

    source(request, response, start_loading_callback, end_loading_callback) {

        if (request.term.trim() === "") {
            if (this.neighbours.length > 0) {
                response(this.neighbours);
            } else if (this.currentLocation) {
                this.currentLocation.reference = this.currentLocation.aid;
                response([this.currentLocation]);
            } else {
                response([]);
            }
            return;
        }

        const airportPromise = $.Deferred();
        const googlePromise = $.Deferred();

        if ($.isFunction(start_loading_callback)) {
            start_loading_callback();
        }

        window.setTimeout(() => {
            googlePromise.resolve([]);
        }, 10000);

        maps_autocomplete_service.getPlacePredictions({
            input: request.term,
            types: ['geocode', 'establishment'],
            delay: 150
        }, (predictions, status) => {
            if (status !== google.maps.places.PlacesServiceStatus.OK) {
                googlePromise.resolve([]);
                return;
            }
            googlePromise.resolve($.map(predictions, (prediction) => {
                return {
                    label: Suggester.highlight_google(prediction.description, prediction.matched_substrings || []),
                    value: prediction.description,
                    reference: prediction.reference,
                    type: Suggester.detectGooglePlace(prediction.types),
                    searchType: 'gp',
                };
            }));
        });

        let cache_key = request.term.trim().toLowerCase();

        if (cache[cache_key] === undefined) {
            let url = this.url + '/' + request.term;

            $.get(url).done((suggestion) => {
                let result = $.map(suggestion, (suggestion) => {
                    let airportCode = suggestion.code ? ` (${suggestion.code}) ` : ''
                    let stateName = suggestion.state_name ? ', ' + suggestion.state_name : ''
                    let country = suggestion.country ? ', ' + suggestion.country : ''
                    let label = suggestion.label + airportCode + stateName + country;
                    return {
                        label: Suggester.highlight_airport(label, request.term),
                        value: label,
                        latlng: suggestion.latlng,
                        reference: suggestion.aid,
                        externalLocId: suggestion.externalLocId,
                        country: suggestion.country,
                        type: suggestion.type,
                        searchType: 'ct'
                    }
                });
                airportPromise.resolve(result);
            }).fail(() => {
                airportPromise.resolve([])
            });
        } else {
            airportPromise.resolve(cache[cache_key]);
        }

        $.when(airportPromise, googlePromise).done((ctLocations, googlePlaces) => {

            cache[cache_key] = ctLocations;
            googlePlaces = googlePlaces.filter(item => {
                return !ctLocations.some(ctLocation => {
                    return ctLocation['externalLocId'] === item.reference
                });
            })

            response([].concat(ctLocations, googlePlaces));
        })
            .fail(() => response([]))
            .always(() => {
                if ($.isFunction(end_loading_callback)) {
                    end_loading_callback();
                }
            });
    }

    select(event, ui, input, callback) {

        input.trigger("autocomplete_select", ui);

        let data = {
            value: ui.item.value
        };

        if (ui.item.searchType === 'ct' || ui.item.searchType === 'current' || ui.item.is_neighbour) {
            if (ui.item.reference === "0") {
                data.aid = null
                data.latLng = ui.item.latlng
                data.country = ui.item.country
            } else {
                data.aid = ui.item.reference;
            }
            callback(data);
        } else {
            if (this.googleDecodeUrl) {
                let url = this.googleDecodeUrl + '?id=' + ui.item.reference;
                $.get(url).done((place) => {
                    if (place.length) {
                        $.extend(data, {
                            latLng: Suggester.getLatLngFromGooglePlace(place),
                            country: place.Country.toLowerCase()
                        });
                        callback(data);
                    } else {
                        this.handleDetailsRequest(ui.item.reference, data, callback);
                    }
                })
            } else {
                this.handleDetailsRequest(ui.item.reference, data, callback);
            }
        }

        return false;
    }

    handleDetailsRequest(reference, data, callback) {
        let request = {
            reference: reference
        };
        maps_places_service.getDetails(request, (loc, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                $.extend(data, {
                    latLng: Suggester.latlng(loc),
                    country: Suggester.getCountryCode(loc)
                });
            } else {
                throw new Error("placesService.getDetails returned not OK");
            }
            callback(data);
        });
    }

    static open(input) {
        let parent = input.parent()
        let w = parseFloat(parent.css('width'));
        let p = parseFloat(parent.css('padding-right'));

        let width = w - p;

        if (width && width !== '0px') {
            input.autocomplete('widget').css({'width': width});
        }

    }

    static renderItem(ul, item) {
        if (item.label) {
            let icon;
            switch (item.type) {
                case 'airport':
                    icon = 'icon-airport-small';
                    break;
                case 'railway':
                    icon = 'icon-train-small';
                    break;
                case 'port':
                    icon = 'icon-ship-small';
                    break;
                case 'city':
                    icon = 'icon-city-small';
                    break;
                default:
                    icon = 'icon-blank-sign';
            }

            icon = $('<i>').addClass('icon ' + icon);
            let element = $('<div>').attr('title', item.value).html("<span>" + item.label + "</span>").prepend(icon);

            return $('<li>').append(element).appendTo(ul)
        }
    }

    static detectGooglePlace(types) {
        if (types.includes('airport')) {
            return 'airport'
        }
        if (types.includes('locality')) {
            return 'city'
        }
        return 'place';
    }

    static highlight_google(text, matched) {
        let result = '';
        let offset = 0;
        let i = 0;
        while (i < matched.length) {
            result += text.substring(offset, matched[i].offset);
            result += '<b>' + text.substr(matched[i].offset, matched[i].length) + '</b>';
            offset = matched[i].offset + matched[i].length;
            i++;
        }
        result += text.substr(offset);
        return result;
    }

    static highlight_airport(text, matched) {
        let re = new RegExp("(" + matched + ")", 'gi');
        return text.replace(re, "<b>$&</b>");
    }

    static latlng(loc) {
        return loc.geometry.location.lat() + ',' + loc.geometry.location.lng();
    }

    static getLatLngFromGooglePlace(place) {
        return place.Lat + ',' + place.Lng;
    }

    static getCountryCode(place) {

        let country_code = null;

        $.each(place.address_components || [], (i, component) => {
            if (component.types.indexOf('country') >= 0) {
                country_code = component.short_name;
                return false;
            }
        });

        return country_code;
    }
}

